import { useRoute } from "vue-router";
import { computed } from "vue";
import { MSP } from "@/constants";

export const useIsMspRoute = () => {
  const { path } = useRoute();
  const isMspRoute = computed(() => path.includes(MSP));

  return { isMspRoute };
};
